var audio_rtlignore_default = {
  "fontElementMap": "DNArk",
  "customPlayer": "EZ6-t",
  "customPlayer_basic": "-a4uM",
  "customPlayer_mobile": "s-xld",
  "audio_coverImg": "Kk6gX",
  "audio_small_cover_image": "jd5PJ",
  "audio_icon_button": "_5lpD8",
  "audio_contextMenu_wrapper": "LrPrB",
  "customPlayer_with_image": "TM5O7",
  "track_wrapper": "YFDO0",
  "trackContainer": "ERK15",
  "audio_download_icon": "ezCph",
  "audio_duration": "GsPQ0",
  "customPlayer_small_fit": "j5sD2",
  "track_sliders_wrapper": "CILIa",
  "audio_volume_wrapper": "HPt9T",
  "volume_slider_wrapper": "CKMV9",
  "audioDetails": "angJt",
  "title": "_7OMzQ",
  "author_name": "hP5Wz",
  "dropdown_menu_wrapper": "Lr4Fg",
  "dropdown_selected_button": "TjJ5j",
  "dropdown_content": "-G1QD",
  "dropdown_content_withIcon": "_2q18u",
  "audio_loader_icon": "x5WYz",
  "spin": "WqS0O"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
